exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".source-form-container {\n  display: -ms-flexbox;\n  display: flex;\n  width: 300px;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n\n.hebrew-format {\n  text-align: right;\n  direction: rtl; }\n\n.gemara-masechta-field {\n  width: 200px; }\n\n.gemara-masechta-select {\n  width: 200px; }\n\n.mishna-masechta-field {\n  width: 200px; }\n\n.mishna-masechta-select {\n  width: 200px; }\n\n.literal-mare-makom-input {\n  direction: rtl; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/source-dialog/source-dialog.scss
// module id = ../../../../../src/app/admin-area/containers/source-dialog/source-dialog.scss
// module chunks = main